
<button class="menu" 
        mat-icon-button (click)="openMenu()"
        [matBadge]="menuText" [matBadgeHidden]="menuBadgeHidden">
  <mat-icon [svgIcon]="menuIcon"></mat-icon>
</button>
